const FONTS = {
    bigTitle: {
        fontFamily: "Bodoni",
        fontWeight: "bold",
        fontSize: "4rem",
        source: "/fonts/Bodoni-11-Bold.ttf",
        forMat: "truetype"
    },
    mediumTitle: {
        fontFamily: "Bodoni",
        fontWeight: "bold",
        fontSize: "2.5rem",
    },
    smallTitle : {
        fontFamily: "Bodoni",
        fontWeight: "bold",
        fontSize: "1.5rem",
    },
    subTitle: {
        fontFamily: "'Courier New',Courier,monospace",
        fontWeight: "bold",
        fontSize: "1rem"
    },
    emphasis: {
        fontFamily: "SourceCode",
        fontWeight: "regular",
        fontSize: "1rem",
        source: "/fonts/SourceCodePro-Medium.ttf",
        forMat: "truetype"
    },
    paraGraphs: {
        fontFamily: "Montserrat",
        fontWeight: "normal",
        fontSize: "1rem",
        source: "/fonts/Montserrat-Regular.ttf",
        forMat: "truetype"
    },
    paraGraphsBold: {
        fontFamily: "Montserrat",
        fontWeight: "bold",
        fontSize: "1rem",
        source: "/fonts/Montserrat-Bold.ttf",
        forMat: "truetype"
    },
    paraGraphsBoldItalic: {
        fontFamily: "Montserrat",
        fontWeight: "bold",
        fontSize: "1rem",
        source: "/fonts/Montserrat-BoldItalic.ttf",
        forMat: "truetype"
    },
};

export default FONTS;